import { useEffect } from "react";

/**
 * 点击元素外部时触发回调
 * @param ref - 目标元素的 ref
 * @param handler - 点击外部时的回调函数
 */
export function useClickOutside(
    ref: React.RefObject<HTMLElement | null>,
    handler: () => void,
) {
    useEffect( () => {
        const handleClickOutside = ( event: MouseEvent ) => {
            if ( ref.current && !ref.current.contains( event.target as Node ) ) {
                handler();
            }
        };

        document.addEventListener( "mousedown", handleClickOutside );
        return () => {
            document.removeEventListener( "mousedown", handleClickOutside );
        };
    }, [ ref, handler ] );
}
